<div app-landing-page-section-container class="items-center mb-0 pb-5 lg:pb-10">
    <div class="mat-headline-6 text-center pb-4" translate>
        LandingPageWagonTrackingTitle
    </div>
    <p class="mt-0 md:mt-4 text-lg text-center" translate>
        LandingPageWagonTrackingSubTitle
    </p>

    <!-- needs to be split in two columns to center it in all resolutions -->
    <div class="flex flex-col sm:flex-row mt-4 md:mt-6 mb-2 md:mb-4">
        <div class="flex flex-col mr-8 md:mr-16 xl:mr-0 xl:flex-row">
            @for (useCase of useCasesLeft; track useCase) {
                <div class="flex flex-row items-center mb-6 xl:mr-16">
                    <mat-icon
                        svgIcon="{{ useCase.icon }}"
                        class="flex-none w-11 h-11 sm:w-14 sm:h-14"
                    ></mat-icon>
                    <div class="flex px-4">
                        <div
                            class="mat-subtitle-2"
                            [innerHTML]="useCase.title | translate"
                        ></div>
                    </div>
                </div>
            }
        </div>
        <div class="flex flex-col xl:flex-row">
            @for (useCase of useCasesRight; track useCase; let first = $first) {
                <div
                    class="flex flex-row mb-6 items-center"
                    [class.xl:mr-16]="first"
                >
                    <mat-icon
                        svgIcon="{{ useCase.icon }}"
                        class="flex-none w-11 h-11 sm:w-14 sm:h-14"
                    ></mat-icon>
                    <div class="flex px-4">
                        <div
                            class="mat-subtitle-2"
                            [innerHTML]="useCase.title | translate"
                        ></div>
                    </div>
                </div>
            }
        </div>
    </div>

    <img
        class="block h-auto max-w-full 2xl:max-w-[927px]"
        src="/assets/images/landing-page/wagon-tracking/wagon-tracking-macbook-927.png"
        alt="Wagon Tracking Image"
    />

    <div class="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-4 md:gap-5">
        @for (useCase of useCasesLeft.concat(useCasesRight); track useCase) {
            <div
                class="bg-white rounded-2xl flex flex-col m-2 p-8 max-w-full lg:max-w-[360px] 2xl:max-w-full"
            >
                <div class="flex flex-row items-center pb-4">
                    <mat-icon
                        svgIcon="{{ useCase.icon }}"
                        class="flex-none w-8 h-8"
                    ></mat-icon>
                    <div
                        class="mat-subtitle-2 pl-4"
                        [innerHTML]="useCase.title | translate"
                    ></div>
                </div>

                <p class="mat-body-1 m-0">
                    {{ useCase.description | translate }}
                </p>

                <ul class="list-none pl-0 m-0">
                    @for (bullet of useCase.bulletPoints; track bullet) {
                        <li
                            class="flex flex-row items-center first:mt-0 my-4 last:mb-0"
                        >
                            <mat-icon
                                svgIcon="check"
                                class="flex-none w-4 h-4"
                                color="primary"
                            ></mat-icon>
                            <p class="text-body-3 pl-3 m-0">
                                {{ bullet | translate }}
                            </p>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
</div>
